import { RestService } from "@sinossi/mates-react-library"

import {
    MatchProposalFilter,
    NewMatchRequest,
    SendNewProposalRequest,
    UpdateProposalRequest,
} from "components/match-proposal/model"
import {
    AssetMatchBrand, AssetMatchBrandWithImage,
    GeoAssetFilter,
    PaginatedResponse, SearchMatchRequest, SearchPriorityMatch
} from "models"

export class MatchService {

    static getTimelineData = (id: string, callback: any, catchCallback: any) => {
        RestService
            .get(`/api/match/${id}/timeline-proposta`)
            .then(callback)
            .catch(catchCallback)
    }

    static getMatchById = (id: string | null, callback: any, catchCallback: any) => {
        RestService
            .get(`/api/match/${id}`)
            .then(callback)
            .catch(catchCallback)
    }

    static getMatchesByCompanyId = (request: SearchPriorityMatch, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrand>>(`/api/match/company`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getMatchesByCompanyIdAndArea = (request: GeoAssetFilter, brandId: string | null, callback: any, catchCallback: any) => {
        let req = {
            ...request,
            brandId: brandId
        }
        RestService
            .post<PaginatedResponse<AssetMatchBrandWithImage>>(`/api/match/company/by-area`, req)
            .then(callback)
            .catch(catchCallback)
    }

    static approveMatch = (id: string | null, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/match/${id}/approve`, {})
            .then(callback)
            .catch(catchCallback)
    }

    static rejectMatch = (id: string | null, body: any, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/match/${id}/reject`, body)
            .then(callback)
            .catch(catchCallback)
    }

    static toggleVisibility = (matchId: string, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/match/${matchId}/visibility`, matchId)
            .then(callback)
            .catch(catchCallback)
    }

    static togglePartialVisibility = (matchId: string, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/match/${matchId}/partial-visibility`, matchId)
            .then(callback)
            .catch(catchCallback)
    }

    static updateNotes = (matchId: string, request: { notes: string }, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/match/${matchId}/notes`, request)
            .then(callback)
            .catch(catchCallback)
    }


    static searchMatch = (brandId: string, request: SearchMatchRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrand>>(`api/brand/${brandId}/match`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static searchMatchBrandDashboard = (brandId: string, request: SearchMatchRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrand>>(`api/brand-dashboard/${brandId}/match`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static filterMatchByBrand = (brandId: string, request: SearchMatchRequest, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrandWithImage>>(`api/brand/${brandId}/match/images`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static filteredMatchesList = (request: MatchProposalFilter, callback: any, catchCallback: any) => {
        RestService
            .post<PaginatedResponse<AssetMatchBrandWithImage>>(`api/match/filtered-matches`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static getVisibleMatch = (assetId: string, callback: any, catchCallback: any) => {
        RestService
            .get<AssetMatchBrand[]>(`api/match/visible-matches?assetId=${assetId}`)
            .then(callback)
            .catch(catchCallback)
    }

    static getNotVisibleMatch = (assetId: string, callback: any, catchCallback: any) => {
        RestService
            .get<AssetMatchBrand[]>(`api/match/not-visible-matches?assetId=${assetId}`)
            .then(callback)
            .catch(catchCallback)
    }

    static createNewMatch = (request: NewMatchRequest, callback: any, catchCallback: any) => {
        RestService
            .post(`api/match/new-match`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static sendNewProposal = (request: SendNewProposalRequest, callback: any, catchCallback: any) => {
        RestService
            .post(`api/match/save-proposta`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static updateProposal = (request: UpdateProposalRequest, assetId: string, brandId: string, callback: any, catchCallback: any) => {
        RestService
            .put(`api/match/update-proposta?assetId=${assetId}&brandId=${brandId}`, request)
            .then(callback)
            .catch(catchCallback)
    }

    static setInterested = (matchId: string, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/match/${matchId}/interested`, {})
            .then(callback)
            .catch(catchCallback)
    }

    static requestAssessment = (matchId: string, callback: any, catchCallback: any) => {
        RestService
            .post(`/api/ai/${matchId}/request-assestment`, {})
            .then(callback)
            .catch(catchCallback)
    }

    static makeMatchVisibleToBrand = (matchId: string, callback: any, catchCallback: any) => {
        RestService
            .put(`/api/match/match-proposal/${matchId}/make-visible`, {})
            .then(callback)
            .catch(catchCallback)
    }
}
